export default function shimRootScope() {
  window["$rootScope"] = {
    $broadcast: function (eventName, data) {},
    C: window["C"],
  };
  window["angular"] = {};
}
